import {Component, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusiness} from '../../../models/my-business';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {CommonModule} from '@angular/common';
import {PackagePanelComponent} from '../package-panel/package-panel.component';

@Component({
  selector: 'app-subscription-update',
  templateUrl: './subscription-update.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, PackagePanelComponent],
  styleUrls: ['./subscription-update.component.scss']
})
export class SubscriptionUpdateComponent implements OnInit {
  submitting;
  submitted;
  myBusiness: MyBusiness;
  lang: any;
  loading: any;

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;

    // get my business
    this.myBusiness = await this.api.getMyBusiness(false);

    // check for shopify
    console.log('my business', this.myBusiness);

    // fill webhooks form data - starting by payment
    setTimeout(async () => {
      await this.loadResources();
      this.loading = false;
      this.lang = await firstValueFrom(this.translate.get('lang'));
    }, 1000);
  }

  // noinspection DuplicatedCode
  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');
  }
}
